import { useState } from "react";
import { Switch } from "../components/ui/switch";

const NotificationsSettingsPage = () => {
  const [pauseAll, setPauseAll] = useState(false);
  const [starred, setStarred] = useState(true);
  const [comments, setComments] = useState(true);
  const [voted, setVoted] = useState(true);

  return (
    <div className="space-y-6" data-testid="notifications-settings-page">
      <div>
        <h2 className="text-2xl font-semibold" data-testid="notifications-settings-title">
          Manage notifications
        </h2>
        <p className="text-sm text-muted-foreground" data-testid="notifications-settings-subtitle">
          Choose which alerts you want to receive.
        </p>
      </div>
      <div className="space-y-4">
        <div className="flex items-center justify-between rounded-xl border border-border bg-card p-4" data-testid="notifications-toggle-pause-all">
          <div>
            <div className="text-sm font-medium">Pause all</div>
            <div className="text-xs text-muted-foreground">Temporarily mute every alert.</div>
          </div>
          <Switch checked={pauseAll} onCheckedChange={setPauseAll} data-testid="notifications-toggle-pause-all-switch" />
        </div>
        <div className="flex items-center justify-between rounded-xl border border-border bg-card p-4" data-testid="notifications-toggle-starred">
          <div>
            <div className="text-sm font-medium">Starred</div>
            <div className="text-xs text-muted-foreground">Activity on polls you starred.</div>
          </div>
          <Switch checked={starred} onCheckedChange={setStarred} data-testid="notifications-toggle-starred-switch" />
        </div>
        <div className="flex items-center justify-between rounded-xl border border-border bg-card p-4" data-testid="notifications-toggle-comments">
          <div>
            <div className="text-sm font-medium">Comments</div>
            <div className="text-xs text-muted-foreground">Replies and comment activity.</div>
          </div>
          <Switch checked={comments} onCheckedChange={setComments} data-testid="notifications-toggle-comments-switch" />
        </div>
        <div className="flex items-center justify-between rounded-xl border border-border bg-card p-4" data-testid="notifications-toggle-voted">
          <div>
            <div className="text-sm font-medium">Voted</div>
            <div className="text-xs text-muted-foreground">Votes on your polls.</div>
          </div>
          <Switch checked={voted} onCheckedChange={setVoted} data-testid="notifications-toggle-voted-switch" />
        </div>
      </div>
    </div>
  );
};

export default NotificationsSettingsPage;
